module.exports = __webpack_public_path__ + "img/AT0000002618906.911e1332.png";